import { REMOVE_REACTIVATE_ACCOUNT_DATA } from './actionTypes';

export default () => ({
  type: REMOVE_REACTIVATE_ACCOUNT_DATA,
  payload: {
  }
});